// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import VueYouTubeEmbed from "vue-youtube-embed";
import DateTime from "./vendor/vue-datetime-picker/";
import App from "./App";
import router from "./router";
import store from "./store";
import VueSignaturePad from "vue-signature-pad";
import "./assets/scss/main.scss";

Vue.config.productionTip = false;

Vue.use(VueYouTubeEmbed);
Vue.use(DateTime);
Vue.use(VueSignaturePad);

Vue.prototype.$log = console.log;

Vue.prototype.$cookiesEnabled = function() {
  var cookieEnabled = navigator.cookieEnabled;
  if (!cookieEnabled) {
    document.cookie = "testcookie";
    cookieEnabled = document.cookie.indexOf("testcookie") != -1;
  }
  return cookieEnabled;
};

if (!String.prototype.startsWith) {
  Object.defineProperty(String.prototype, "startsWith", {
    value: function(search, rawPos) {
      var pos = rawPos > 0 ? rawPos | 0 : 0;
      return this.substring(pos, pos + search.length) === search;
    }
  });
}

Vue.prototype.$isImage = function(file) {
  return (file.type || "").match(/image\/.*/) != null;
};

// window.debugProcess = true;

/* eslint-disable no-new */
// new Vue({
//   el: '#app',
//   store,
//   router,
//   template: '<App/>',
//   components: { App },
// });
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
